import { render } from "./insure-worker.vue?vue&type=template&id=957246a6&scoped=true&ts=true"
import script from "./insure-worker.vue?vue&type=script&lang=ts"
export * from "./insure-worker.vue?vue&type=script&lang=ts"

import "./insure-worker.vue?vue&type=style&index=0&id=957246a6&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957246a6"]])

export default __exports__